import { Smartphone, Download, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

const APP_VERSION = "1.0.200";
const APP_BUILD = "3";
const APK_URL = "https://zmtqkgtavnzkxxcebzxm.supabase.co/storage/v1/object/public/APK/AgroAluga-v1.0.200-build3.apk";

export default function DownloadPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16 max-w-2xl">
        <div className="text-center mb-10">
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center shadow-lg">
              <Smartphone className="h-10 w-10 text-primary-foreground" />
            </div>
          </div>
          <h1 className="text-3xl font-heading font-bold mb-2">AgroAluga App</h1>
          <p className="text-muted-foreground">Baixe o aplicativo para Android e tenha o agronegócio na palma da mão.</p>
        </div>
        <div className="bg-card border border-border rounded-2xl p-8 shadow-sm mb-6">
          <div className="flex items-center justify-between mb-6 pb-4 border-b border-border">
            <div>
              <p className="text-sm text-muted-foreground">Versão atual</p>
              <p className="text-2xl font-bold font-heading text-primary">v{APP_VERSION}</p>
              <p className="text-xs text-muted-foreground">Build {APP_BUILD}</p>
            </div>
            <div className="text-right">
              <p className="text-sm text-muted-foreground">Plataforma</p>
              <p className="font-semibold">Android</p>
            </div>
          </div>
          <div className="space-y-3 mb-8">
            {["Busca por equipamentos e serviços agrícolas","Mapa interativo com pins por categoria","Notificações em tempo real","Favoritos e mensagens"].map((f) => (
              <div key={f} className="flex items-center gap-3">
                <CheckCircle className="h-5 w-5 text-primary shrink-0" />
                <span className="text-sm">{f}</span>
              </div>
            ))}
          </div>
          <a href={APK_URL} download className="block">
            <button className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold py-4 rounded-xl flex items-center justify-center gap-3 text-lg transition-colors">
              <Download className="h-6 w-6" /> Baixar APK — v{APP_VERSION}
            </button>
          </a>
          <p className="text-xs text-muted-foreground text-center mt-3">Ao instalar, permita instalação de fontes desconhecidas nas configurações do Android.</p>
        </div>
        <div className="text-center mt-8">
          <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">← Voltar para o site</Link>
        </div>
      </div>
    </div>
  );
}
